function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as d3 from 'd3';
export var TimeUtils = /*#__PURE__*/function () {
  function TimeUtils() {}

  TimeUtils.formatTime = function formatTime(datelike) {
    datelike = new Date(datelike);
    return datelike.toLocaleString('nb-NO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  TimeUtils.toDate = function toDate(timestamplike) {
    // Convert to string
    timestamplike = timestamplike.toString(); // Extract parts

    var year = timestamplike.substring(0, 4);
    var month = timestamplike.substring(4, 6);
    var day = timestamplike.substring(6, 8);
    var hour = timestamplike.substring(8, 10);
    var minute = timestamplike.substring(10, 12); // Construct date string and create date

    return new Date(year + '-' + month + '-' + day + 'T' + hour + ':' + minute);
  }
  /**
   * Return a UTC date
   *
   * @param {*} year Year
   * @param {*} month Month of year 1-12
   * @param {*} day Day of month 1-31
   */
  ;

  TimeUtils.utcDate = function utcDate(year, month, day) {
    var d;

    if (day !== undefined && !isNaN(day) && day >= 1 && day <= 31) {
      d = new Date(year, month - 1, day);
    } else {
      d = new Date(year, month - 1);
    }

    d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
    return d;
  }
  /**
   * Add a month to a date
   *
   * @param {*} currentDate JavaScript date object
   * @param {*} numMonths Number of months to add
   */
  ;

  TimeUtils.addMonths = function addMonths(currentDate, numMonths) {
    currentDate.setMonth(currentDate.getMonth() + numMonths);
    return currentDate;
  };

  return TimeUtils;
}();

_defineProperty(TimeUtils, "toTimestamp", d3.timeFormat('%Y%m%d%H%M'));

_defineProperty(TimeUtils, "toCompactTimestring", d3.timeFormat('%d.%m.%y %H:%M'));

_defineProperty(TimeUtils, "toCompactDate", d3.timeFormat('%Y-%m-%d'));

export default TimeUtils;